angular.module('bribac.views.listRuleSets', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.entities.ruleSetFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.ruleSetDetails'
])

  .config(function(
    $routeProvider
  ) {
    var config = {
      templateUrl: 'list-rule-sets-view.html',
      controller: 'ListRuleSetsViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: /*@ngInject*/ function(routeAuth) {return routeAuth.requireAuth()}}
    }

    $routeProvider.when('/settings', config)
    $routeProvider.when('/templates/settings', config)
  })

  .controller('ListRuleSetsViewCtrl', function(
    $scope,
    $location,
    KINDS,
    ruleSetFactory,
    api,
    permissions
  ) {
    var $ctrl = this
    $ctrl.organization = {}
    $ctrl.permissions = permissions

    $ctrl.pathPrefix = $location.path()

    $ctrl.ruleSetsPromise = api.get(KINDS.RULE_SET).then(function(request) {
      $ctrl.ruleSets = request.data.list
      $ctrl.allRuleSets = request.data.list
      if ($ctrl.permissions.canManageOrganizations()) {
        $scope.$watch('$ctrl.organization', filterRuleSets)
      }
    })

    function filterRuleSets() {
      if ($ctrl.organization.id != -1) {
        var filtered = $ctrl.allRuleSets.filter(function(item) {
          return item.organization.id === $ctrl.organization.id
        })
        $ctrl.ruleSets = filtered
      } else {
        $ctrl.ruleSets = $ctrl.allRuleSets
      }
    }
  })
